var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16834",
    transform: "translate(22689 -8712)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 18361",
    width: 20,
    height: 20,
    rx: 10,
    transform: "translate(-22689 8712)",
    style: {
      fill: "none",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4 2A1.4 1.4 0 0 0 3 3.4v9.1h1.4V3.4h7V2zm2.8 2.8a1.4 1.4 0 0 0-1.4 1.4v8.4A1.4 1.4 0 0 0 7.2 16h6.3a1.4 1.4 0 0 0 1.4-1.4V6.2a1.4 1.4 0 0 0-1.4-1.4zm0 1.4h6.3v8.4H7.2z",
    transform: "translate(-22688 8713)",
    style: {
      fill: "#696c80"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.aaa6f74e.svg";
export { ForwardRef as ReactComponent };